import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ellipsis' })
export class EllipsisPipe implements PipeTransform {

    transform(value: string, maxLength: number): string {
        return value.length > maxLength ? value.substr(0, maxLength) + '...' : value;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/ellipsis.pipe.ts